/* eslint-disable prettier/prettier */

import IncomeServices from "src/services/incomeServices";
import { incomeConstants } from "../constants/incomeConstants";

export const levelIncomeAction = (header) => (dispatch) => {
    IncomeServices.levelIncome(header)
        .then((data) => {
            dispatch({
                type: incomeConstants.FETCHING_LEVEL_INCOME_API_SUCCESS,
                payload: data.data
            })
        }).catch((err) => {
            dispatch({
                type: incomeConstants.FETCHING_LEVEL_INCOME_API_FAILED,
                payload: err.message
            })
        })
}
export const rewardIncomeAction = (header) => (dispatch) => {
    IncomeServices.rewardIncome(header)
        .then((data) => {
            dispatch({
                type: incomeConstants.FETCHING_REWARD_INCOME_API_SUCCESS,
                payload: data.data
            })
        }).catch((err) => {
            dispatch({
                type: incomeConstants.FETCHING_REWARD_INCOME_API_FAILED,
                payload: err.message
            })
        })
}
export const taskIncomeAction = (header) => (dispatch) => {
    IncomeServices.taskIncome(header)
        .then((data) => {
            dispatch({
                type: incomeConstants.FETCHING_TASK_INCOME_API_SUCCESS,
                payload: data.data
            })
        }).catch((err) => {
            dispatch({
                type: incomeConstants.FETCHING_TASK_INCOME_API_FAILED,
                payload: err.message
            })
        })
}